import {useAppSelector} from '@app/redux/reduxHooks';
import {EUserRole} from '@app/constants';
import {userSelector} from '@app/redux/slices/userSlice';

export const useUserRole = (): EUserRole | undefined =>
  useAppSelector(userSelector)?.role;
